import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useNavigate } from "react-router-dom";
import { IMG_BASE_URL } from "../../../../config/Config";

const GemstoneCarousel = (homeData) => {
  const navigate = useNavigate();
  const category_list = Array.isArray(homeData?.data?.category) ? homeData?.data?.category : [];
  const slidesToShow = category_list?.length < 5 ? category_list?.length : 5;

  const settings = {
    infinite: category_list?.length > 1,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: category_list?.length > 1,
    autoplaySpeed: 2000,
    arrows: category_list?.length > 1,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: category_list?.length < 3 ? category_list?.length : 3,
          variableWidth: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: category_list?.length < 2 ? category_list?.length : 2,
          variableWidth: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        },
      },
    ],
  };



  return (
    <section className="gi-deal-section py-[40px] max-[767px]:py-[30px]">
      <div className="flex flex-wrap justify-between items-center mx-auto min-[1600px]:max-w-[1450px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
        <div className="w-full px-[12px] overflow-hidden">
          <div className="gi-deal-section w-full">
            <div className="gi-products">
              <div className="gi-tab-title grid grid-cols-1 gap-3 items-center">
                <div className="section-detail text-center">
                  <h2 className="bodonibook_font text-3xl font-bold text-gray-900 relative inline-block capitalize">
                    {/* Buy Gemstone As Per Your Stars */} All Category
                  </h2>
                  <p className="mt-[5px] text-[14px] font-semibold text-gray-700 capitalize">Products of trusted excellence</p>
                </div>
              </div>

              <div className="gi-deal-block">
                <div className="inline-block w-full">
                  <Slider {...settings} className="z-0">
                    {category_list?.length > 0 ? (
                      category_list.map((category_list_result, index) => (
                        <div
                          key={index}
                          className="gi-product-content h-full px-3 py-10"
                        // style={{ width: "330px" }}
                        >
                          <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-lg shadow-custome" onClick={() => {
                            navigate(`/${category_list_result?.slug}`)
                            localStorage.setItem("category_list_result_slug", category_list_result?.slug);
                          }}>
                            <div className="relative">
                              <img
                                className="aspect-[calc(4*3+1)/16] object-cover object-center w-full mx-auto"
                                src={`${IMG_BASE_URL}${category_list_result?.image}`}
                                alt={category_list_result?.image_alt}
                              />

                              <div className="p-5 h-full absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-[#00000042] text-center flex flex-col justify-end">
                                <h5 className="gi-pro-stitle mt-3 text-white text-[15px] font-semibold capitalize overflow-hidden whitespace-nowrap text-ellipsis">
                                  {category_list_result?.title}
                                </h5>

                                <button
                                  type="button"
                                  className="text-[12px] inline-block uppercase border border-white text-white font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto w-[150px]"
                                >
                                  View More
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No categories available</p>
                    )}
                  </Slider>
                </div>
              </div>
              <div className="w-full text-center inline-block"
              >
                <Link to="/all-categories" className="text-[13px] inline-block uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white">
                  View All
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GemstoneCarousel;


